import React, { Component } from "react";
import Helmet from "react-helmet";
import BiographicData from "./biodata";
import TransactionHistoryWithTimeline from "./transaction-history-with-timeline";
import LoadingWrapper from "../common/loading-wrapper";
import PatentCenterLink from "../common/links/patent-center-link";
import NotFound from "./not-found";
import { getCaseDetail } from "../../services/api-reexam";
import { lowerCase, startCase } from "lodash";
import { PUBLIC_URL } from "../../config";

const styles = {
  body: {
    width: "100%",
    padding: 30
  },
  gutter: {
    marginTop: 16
  },
  reportErrorLink: {
    float: "right",
    fontWeight: 400,
    fontSize: "0.7em"
  }
};

class Case extends Component {
  state = {
    caseData: {},
    caseDocketsData: [],
    caseLoading: true,
    caseDocketsLoading: true
  };

  componentDidMount() {
    this._isMounted = true;
    const appNumber = this.props.params.appnum;
    this._getCase(appNumber);
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  render() {
    const { caseData, caseLoading, caseDocketsLoading } = this.state;
    let keywords = [
      `${caseData.application_number}`,
      `Ex Parte Reexamination`,
      `Ex-Parte`,
      `US Challenges`,
      `${caseData.patent_number}`,
    ];
    let description = `Case metadata and documents for ${caseData.application_number}, US.`;
    const helmet = {
      title: `${caseData.application_number} - ${caseData.invention_title}`,
      meta: [
        {
          name: "keywords",
          content: keywords.join(","),
        },
        {
          name: "description",
          content: description,
        },
      ],
      link: [
        {
          rel: "canonical",
          href: encodeURI(
            PUBLIC_URL + decodeURI(this.props.router.location.pathname)
          ),
        },
      ],
    };
    return (
      <div style={styles.body}>
        <Helmet {...helmet} />
        <LoadingWrapper loading={caseLoading || caseDocketsLoading}>
          {caseData.application_number ? (
            <>
              <h2>
                {caseData.invention_title
                  ? `${this.props.params.appnum} - ${startCase(lowerCase(caseData.invention_title))}`
                  : this.props.params.appnum}
                <PatentCenterLink value={this.props.params.appnum} />
              </h2>
              <div style={styles.gutter}>
                <BiographicData data={caseData} loading={caseLoading} />
              </div>
              <div style={styles.gutter}>
                <TransactionHistoryWithTimeline data={caseData} loading={caseDocketsLoading} />
              </div>
            </>
          ) : (
            <NotFound />
          )}
        </LoadingWrapper>
      </div>
    );
  }

  _getCase = caseNumber => {
    if (this._isMounted)
      this.setState({
        caseLoading: true,
        caseDocketsLoading: true
      });
    getCaseDetail(caseNumber)
      .then(json => {
        if (this._isMounted)
          this.setState({
            caseData: {
              ...json._source
            },
            caseLoading: false,
            caseDocketsLoading: false
          });
      })
      .catch(() => {
        if (this._isMounted)
          this.setState({
            caseData: {},
            caseDocketsData: [],
            caseLoading: false,
            caseDocketsLoading: false
          });
      });
  };
}

export default Case;
